import { TradingOffersListProvider } from '../pages/TradingOffersList/context/TradingOffersListContext';
import TradingOffersList from '../pages/TradingOffersList';

const TradingOffersListContainer = () => (
  <TradingOffersListProvider>
    <TradingOffersList />
  </TradingOffersListProvider>
);

export default TradingOffersListContainer;
